import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CustomTooltip from './CustomTooltip'
import TooltipElement from './TooltipElement'
import './SpeedChart.css'
import { FaAngleUp, FaAngleDown } from 'react-icons/fa'
import {
  LineChart,
  Label,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts'

const SpeedChart = props => {
  const elements = {
    speed: { color: '#EC6666', label: 'Driving Speed' },
    postedSpeed: { color: '#1374CC', label: 'Posted Speed' },
    postedSpeedTrailer: { color: '#92D052', label: 'Posted Speed Trailer' },
    postedSpeedHGV: { color: '#FED600', label: 'Posted Speed HGV' }
  }
  const [data] = useState(props.data)
  const [units] = useState(props.unitsString)
  const [shelfClosed, setShelfClose] = useState(false)
  const [chartHeight, setChartHeight] = useState(250)
  const maxSpeed = Math.floor(
    1.15 *
      Math.max(
        ...data
          .map(e => Number.parseInt(e.speed) || 0)
          .concat(data.map(e => Number.parseInt(e.postedSpeed) || 0))
      )
  )
  function tooltipContent (tooltipProps) {
    return <CustomTooltip details={tooltipProps.payload} units={units} />
  }

  function toggleShelf () {
    setChartHeight(shelfClosed ? 250 : 0)
    setShelfClose(!shelfClosed)
  }

  return (
    <div>
      <div className={'chartHeaderContainer'} onClick={toggleShelf}>
        <div className={'chartLabel'}>
          Speed profile
          {shelfClosed ? (
            <FaAngleUp className={'shelfArrow'} />
          ) : (
            <FaAngleDown className={'shelfArrow'} />
          )}
        </div>
        <div className={'innerContainer'}>
          {Object.values(elements).map((el, index) => (
            <TooltipElement
              key={index + el.label}
              color={el.color}
              label={el.label}
            />
          ))}
        </div>
        <div className={'chartsLegendClosed'}></div>
      </div>

      <ResponsiveContainer
        width='98%'
        height={chartHeight}
        className={'smoothTransition'}
      >
        <LineChart data={data} onClick={point => props.cb(point)}>
          <XAxis
            dataKey={'time'}
            stroke={'#898787'}
            fontSize={12}
            // fontFamily={'Roboto, Helvetica, sans-serif'}
          />
          <YAxis
            stroke={'#898787'}
            fontSize={12}
            // fontFamily={'Roboto, Helvetica, sans-serif'}
            domain={[0, maxSpeed]}
          >
            <Label
              angle={-90}
              // fontFamily={'Roboto, Helvetica, sans-serif'}
              fontSize={11}
              fill={'#898787'}
              value={'Speed(' + units + ')'}
            />
          </YAxis>
          <Tooltip wrapperStyle={{}} content={tooltipContent} />
          <CartesianGrid
            strokeDasharray='0'
            color={'#a0a0a0'}
            vertical={false}
          />
          <Line
            dot={false}
            type='monotone'
            name={elements.speed.label}
            dataKey='speed'
            stroke={elements.speed.color}
            strokeWidth={3}
          />
          <Line
            dot={false}
            name={elements.postedSpeed.label}
            type='monotone'
            dataKey='postedSpeed'
            stroke={elements.postedSpeed.color}
            strokeWidth={3}
          />
          <Line
            dot={false}
            name={elements.postedSpeedTrailer.label}
            type='monotone'
            dataKey='postedSpeedTrailer'
            stroke={elements.postedSpeedTrailer.color}
            strokeWidth={3}
          />
          <Line
            dot={false}
            name={elements.postedSpeedHGV.label}
            type='monotone'
            dataKey='postedSpeedHgv'
            stroke={elements.postedSpeedHGV.color}
            strokeWidth={3}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}

SpeedChart.propTypes = {
  data: PropTypes.array.isRequired,
  unitsString: PropTypes.string.isRequired
}

export default SpeedChart
